import * as yup from "yup";

const LoginPageValidation = yup.object().shape({
	email: yup.string().email().required(),
	password: yup.string().required(),
});

export default LoginPageValidation;
